import { useGetHttp } from "../../../../../hooks/http/http.hook";
import type { IBrands } from "./get-workspace.hook";

interface IResponse {
	brand: IBrands;
}

export function useJoinWorkspaceHttp() {
	return useGetHttp<IResponse>({
		path: "/brand/brands/:id/join",
	});
}
